
import Post16Summary from "../summary/Post15Summary";

const Post16 = (lang, smallScreen) => {
	let content
	let width= smallScreen? "90%": "600px"
	let widthSmall = "300px"
	if (lang === 'rom') {
		const romText = `
# Cutremur

Am norocul să locuiesc într-un oraș care găzduiește la fiecare doi ani un festival de poeziei. Am participat la câteva spectacole, fiecare dintre ele speciale și emoționante în moduri diferite. Cu cativa ani în urma, unul dintre poeții prezentați, al cărui nume îmi scapă acum, și el prezentator la BBC4, ne-a introdus într-o formă de poezie autobiografică în care, în esență, ne spunea o anumită poveste a vieții sale și apoi, cumva, din anecdotă, poemul avea să devină ceva mai profund, emoționant și universal.

Cred că mă gândeam deja să găsesc o modalitate de a da un sens evenimentelor majore din viața mea (asta a fost înainte să dau peste formatul acestui blog) și am încercat să fac la fel ca acest poet. Nu am ajuns la stadiul „ceva mai profund” dar m-am gândit că ar putea fi interesant să contrastez diferitele perspective, cea a unui adult și a unui copil, despre un eveniment din prima copilărie, un cutremur care a ucis peste 1500 de oameni în România, majoritatea din București si alti 11000 de oameni raniti.

Imaginile pe care le-am folosit aici sunt imagini istorice din centrul Bucurestiului, copyrightul autorului. Nu am imagini personale de la acest eveniment.
<img src="./post16/collage16l.jpg"
     style="display: block; margin: auto; width: ${width}" />

Mai târziu, tatăl meu mi-a povestit cum a trăit evenimentul de la marcajul pe care îl făcea ca profesor în acea seară, până la schimbarea rapidă la teroare absolută, de la capătul lumii, care i-a făcut pe părinții mei să se gândească să sară cu doi copii mici de la etajul al doilea al blocului, în speranța că copacii din jurul lui ar putea să ne spargă căderea și să putem supraviețui când alternativa părea să fie toată casa, să știi că trebuie să treci pe scară. ieși sunt cele mai vulnerabile in caz de cutremur. Din fericire, s-au hotărât să nu iasă pe calea obișnuită, iar scările au rezistat. 
Între timp, protejată de inocența copilăriei timpurii, m-am distrat de minune, de parcă era o petrecere de noapte (era de fapt ora 21.22 când a avut loc cutremurul) odată ce părinții mei au decis să ne scoată afară și să rămână alături de toți cei din țară și chiar din țările vecine. Împreună cu câțiva dintre copiii vecinilor noștri, fratele meu și cu mine am fost împachetate în Dacia tatălui meu și conduși în curtea școlii din apropiere, departe de clădirile de unde ar putea cădea moloz. Copiii și-au petrecut noaptea în mașină chicotind și discutând înainte de a adormi, în timp ce adulții și-au petrecut noaptea afară temându-se de replici.

În acele zile de dinaintea telefoanelor mobile și cu liniile fixe la îndemână, oamenii, inclusiv rudele și prietenii noștri din zonă veneau pe jos în miezul nopții, neștiind ce vor găsi când ajungeam eu.

Iată cele două perspective.

_Noaptea Cutremurului<br/><br/>
O noapte de primăvară, copiii dormeau,<br/>
 Un film de văzut,  teze  de corectat.<br/>
 Ce-a fost asta?! Adâncurile se rupeau<br/>
 Zguduind, și deodată … s-a întunecat.<br/><br/>
Cutremurul! Mai tare și mai tare!<br/>
 Copiii! Trebuie să-i scoatem afară!<br/>
 Să sărim? Mai durează oare?<br/>
 Gata? Sa ieșim până nu începe iară!<br/><br/>
Nu, stați! Înapoi – e frig în noapte!<br/>
 Luați cizme, căciuli si paltoane.<br/>
 Cheile, o pătură, șosete— pe trepte<br/>
 Să ieșim o data, departe de balcoane!<br/><br/>
Vecinii coboară-n grabă și spaimă,<br/>
Ținând ce-au mai scump. Marea  teamă.<br/>
 Cine a ieșit? Cine lipsește? Poti<br/>
 doar spera, sa ne rugăm să iasă toți,.<br/><br/>
Hai să punem copiii în mașină,<br/>
 Să-i ducem undeva mai departe.<br/>
 Nu știm când ne întoarcem în rutină,<br/>
 Dar deocamdată... să fie cât mai departe.<br/><br/>
Stau toți în tăcere, tremurând speriați ,<br/>
Ce va voi Dumnezeu – își spun resemnati.<br/>_

<br/><br/>
Si experienta mea de copil:

_Dar de ce? <br/><br/>
Sunt așa de obosită – îmi vine să plâng.<br/>
 De ce mă scoți din pat, ce pătura să strâng?<br/>
 Aici era cald, frumos si moale…<br/>
 De ce mă tragi afară cu picioarele goale?<br/>
Și pe Cornel? îl trezești și pe el?<br/>
 El abia a adormit nițel…<br/>
 Dar de ce?<br/>
Să ieșim afară? Cum adică… acum?<br/>
Unde sa iesim? Chiar în drum?<br/>
Toată lumea e afară! Ce nebunie e acum!<br/>
Dar de ce?<br/>
Uite! Miha și Angela sunt aici,<br/>
Ozana și Dana, și Anda, desigur – toți ǎi mici!<br/>
Dar de ce?<br/>
În mașină? Noi toți? Ce sa vezi!<br/>
Parcă-i autobuz de copii, iti vine sa crezi? <br/>
Tata ne duce in curtea scolii, noaptea! ce sa zic?<br/>
Toți suntem afară – cu mare, cu mic.<br/>
Dar de ce?<br/>
„Ce pijama drăguță ai!”<br/>
 „Ți-ai pierdut soseta, vai!”<br/>
 „Cred că-i în fața blocului, hai!”<br/>
 „Nu mă împinge!”<br/>
 „Nu mă gâdila, nu mă strânge!”<br/>
“Cred c-am pierdut un papuc!”<br/>
 „Am nevoie la baie, mă duc, mă duc!”<br/>
 „Nu poți aștepta până mâine, un pic?”<br/>
“Nu, vreau sa mă ridic!”<br/>
 „Atunci du-te după tufiș!”<br/>
 „Pssst! ce te uiți crucis?!”<br/>
 „Îmi place noaptea asta, e altfel!”<br/>
“Da, toti afara, cu catel si purcel”<br/>
 “Unde mi-e un cercel?”<br/>
“Imi clantane dinții!”<br/>
“Ssst, ne privesc părinții!!” <br/>
"Hai, gata! Tot vorbim si glumim.<br/>
Cred că ar trebui să dormim"<br/>
 "Sub paltoane ne-am strâns frumos.<br/>
 Mamele-s aproape, și totu-i pe  dos."<br/>
"Noapte bună!Somn ușor! Vise plăcute,<br/>
Puricii sa te sarute! "<br/>
“Sa n-aud de purici?!”<br/>
“Ai si tu niste frici!”<br/>
“Hai, puişor! “<br/>
“Somn uşor!”<br/>_
Atita pierdere in noaptea aia! Atita viata, talent, potential, pierdut in acel [minut tragic](https://en.wikipedia.org/wiki/1977_Vrancea_earthquake#Notable_victims).

Eu si familia mea am fost printre cei norocosi.

`
		content = romText
	} else { 
const postText = `
#Earthquake



I am lucky to live in a city that hosts a Poetry festival every other year. I attended a few sessions, each of them thought provoking and touching in different ways. 
A few years ago, one of the poets featured, whose name escapes me now, also a presenter for BBC4,  introduced a form of autobiographical poetry in which he'd essentially tell us a certain story of his life and then somehow, from anecdote, the poem would become something deeper and universal.

I think I was already thinking of finding a way of making sense of the major events of my life( this was before I stumbled on the format of this blog) and I tried to do the same as this poet.
I did not get to the "something deeper" stage but I thought it might be interesting to contrast the different perspectives, that of an adult and a child, about an event from my early childhood, an earthquake that killed over 1500 people in Romania, most of them from Bucharest with another 11,000 injured.

The images I used here are historic images from the center of Bucharest, credit belongs to the owner. I have no personal images from this event.

<img src="./post16/collage16l.jpg"
     style="display: block; margin: auto; width: ${width}" />

My father later told me how he lived the event: the marking he was doing as the teacher that evening, the sudden change to sheer, end-of-the-world-terror that made my parents considered jumping with two young children from the second floor of the block of flats  in the hope that the trees around it might break our fall and we could survive when the alternative seemed to be the whole house collapsing on top of us. The stairs are often the most vulnerable part of a house in the case of an earthquake and, indeed, many of the victims were trapped by the falling stairs. Thankfully, my parents decided against jumping and  got out the usual way and the stairs held on. 
<br/>
The earthquake took place at 9.22pm. My parents stayed out that night along with most people in the country, and, even, neighbouring countries fearing aftershocks. In those days before mobile phones and with land lines out of reach, people, including our relatives and friends from the area, would come on foot in the middle of the night to check on each other, not knowing what they would find once they got there. It was a terrible night.

Meanwhile, protected by the innocence of early childhood, I had a jolly good time, like it was a night party .
Along with a few of our neighbours’ children, my brother and I were packed in my dad’s Dacia and driven to a nearby school yard, away from the buildings from where debris might fall . Us children spent the night in the car giggling and chatting before falling asleep.


Here are the two poems.

<p style="text-align: center;">
_The Tremor <br/><br/>
That spring night - full moon, kids asleep<br/>
A film on TV,  some tests left to mark.<br/>
What is this?! A thunder from deep<br/>
Shaking and breaking- then sudden dark.<br/><br/>
The tremor! Stronger and stronger!<br/>
The children! We must get them out!<br/>
Shall we jump? Just how much longer?<br/>
Has it stopped? Run now, all out!<br/>
No, wait! Come back! Outside it’s so cold!<br/>
Get coats, boots, socks and hats<br/>
The car keys, a blanket to hold<br/><br/>
We all must get out of the flats!<br/>
The neighbours rush down in a stream,<br/>
Clutching their treasures and fears<br/>
Who made it? Do I hear a scream?<br/>
Pray that everyone appears.<br/><br/>
Let’s load the kids in the car<br/>
And drive just far enough, to be clear.<br/>
When can we go back? It’s bizarre-<br/>
The silence, the waiting, the fear.<br/><br/>
They stand in silence, cold and still<br/>
Placing  their hopes in God’s own will._
</p>

<br/><br/>
And my impression of the event:

_But Why?<br/><br/>
I am so tired—I might just weep.<br/>
 Why would you make me leap<br/>
 Out of my bed, so soft and deep,<br/>
 And from beneath this cozy heap?<br/>
And you wake up Cornel too!<br/>
 He only slept like a minute or two!<br/>
 But why?<br/>
Go outside? What? Right now?<br/>
 Why would you even allow?<br/>
 Everyone’s out?! Oh wow!<br/>
But why?<br/>
Oh look—Miha and Angela are here,<br/>
 Ozana and Dana, Anda is near!<br/>
But why?<br/>
In the car? All of us?<br/>
 It’s like a mini children bus!<br/>
 Like Dad drives on the schoolyard ground—<br/>
 Everyone’s out in this mad town!<br/>
But why?<br/>
“I love your jammies!”<br/>
“Shall we go to the granny’s?”<br/>
 “You lost a sock and a shoe!”<br/>
 “They’re probably near the bloc’s front, too!”<br/>
 “Do I feel anything prickle?”<br/>
 “Don’t tickle!”<br/>
“Where is my earring, then?”<br/>
“What's in your pocket!”, ” A pen.”<br/>
 “That’s funny, but I really need to go!”<br/>
 “Can’t wait till tomorrow?”<br/>
 “Go then, in the bush!”<br/>
 “Shush!”<br/>
 “I like it tonight!”<br/>
 “i’m scared”<br/>
 “Parents are there,<br/>
it’s alright!”<br/>
"I think we should sleep."<br/>
"We’re quite a heap—<br/>
 Buried deep under coats."<br/>
 "Our mums are really close."<br/>
"Sleep tight!<br/>
Don’t let the bed bugs bite"<br/>
"Oh, no, I don't want any bug!”<br/>
“Don’t be silly, have a hug”<br/>
 G’night!<br/>
 Nighty night!_








So much loss that night! So much potential, talent, promise, wiped out in that [fateful minute](https://en.wikipedia.org/wiki/1977_Vrancea_earthquake#Notable_victims).

My family and I were among the lucky ones.


`
    content = postText
	}


const summary = Post16Summary(lang)
return {
	content,
	linkId: summary.linkId,
	title: summary.cardTitle
}
}

export default Post16;
